<div id="work" class="services-area">
  <div class="container">
    <div class="section-title">
      <h2>Nuestro <span>Trabajo</span></h2>
      <p>En el Centro de Investigaciones en Desarrollo Humano, nos enfocamos en abordar de manera
        multidisciplinar diversos campos del conocimiento que representan nuestro compromiso con
      el conocimiento científico, la innovación y la transformación social.</p><br>
      <p>Estas son nuestras publicaciones de acuerdo a las líneas de investigación.</p>
    </div>
  </div>
  <div class="container">
    <div class="publication-browser">
      @if (loadError) {
        <p role="alert">{{ loadError }}</p>
      }
      <div class="catalog-toolbar">
        <div class="filter-field filter-field--search">
          <label class="filter-label" for="publication-search">Buscar publicación</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-search filter-icon"></i>
            <input id="publication-search"
              class="filter-input"
              type="text"
              (keyup)="applyFilter($event.target.value)"
              placeholder="Título, autor, revista...">
            </div>
          </div>

          <div class="filter-field">
            <label id="publication-type-label" class="filter-label" (click)="typeSelect.focus()">Tipo de publicación</label>
            <mat-select #typeSelect
              class="filter-select"
              value=""
              panelClass="publication-select-panel"
              aria-labelledby="publication-type-label"
              (selectionChange)="applyTipoFilter($event.value)">
            <mat-option value="">Todos</mat-option>
            @for (tipo of tipoProductoList; track tipo) {
              <mat-option [value]="tipo.idTipoProducto">
                {{ tipo.descripcion }}
              </mat-option>
            }
          </mat-select>
        </div>

        <div class="filter-field">
          <label id="publication-sort-label" class="filter-label" (click)="sortSelect.focus()">Ordenar por</label>
          <mat-select #sortSelect
            class="filter-select"
            value="year-desc"
            panelClass="publication-select-panel"
            aria-labelledby="publication-sort-label"
            (selectionChange)="applySort($event.value)">
            <mat-option value="year-desc">Año: más recientes</mat-option>
            <mat-option value="year-asc">Año: más antiguos</mat-option>
            <mat-option value="title-asc">Título: A–Z</mat-option>
            <mat-option value="title-desc">Título: Z–A</mat-option>
          </mat-select>
        </div>
      </div>

      <div class="publication-catalog">
        @if (productoList && productoList.length > 0) {
          @for (producto of sortedProductoList | paginate: { id: 'publications', itemsPerPage: tamanoTabl.value, currentPage: page }; track producto) {
            <article class="publication-card"
              >
              <div class="publication-content">
                <h3>{{ producto.titulo }}</h3>
                <p class="publication-authors">
                  <span>Autores</span>
                  {{ producto.autores || 'Sin autores registrados' }}
                </p>
                <p class="publication-journal">
                  <span>Revista</span>
                  {{ producto.revista || 'Sin revista registrada' }}
                </p>
              </div>
              <div class="publication-meta">
                <span class="publication-year">{{ producto.anio }}</span>
                <div class="publication-details">
                  @if (producto.paginas) {
                    <span>
                      <i class="far fa-file-alt" aria-hidden="true"></i>
                      Páginas {{ producto.paginas }}
                    </span>
                  }
                  @if (producto.isbn && producto.isbn !== 'N') {
                    <span>
                      <i class="fas fa-barcode" aria-hidden="true"></i>
                      ISBN {{ producto.isbn }}
                    </span>
                  }
                  @if (producto.doi && producto.doi !== 'N') {
                    <a
                      [href]="producto.doi"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="doi-link"
                      [attr.aria-label]="'Ver DOI de ' + producto.titulo"
                      title="Ver DOI">
                      <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                      <span>Ver DOI</span>
                    </a>
                  }
                </div>
              </div>
            </article>
          }
        } @else {
          <div class="no-trabajos-message">
            {{ loadError ? '' : 'No hay publicaciones que coincidan con la búsqueda.' }}
          </div>
        }

      </div>

      @if (productoList && productoList.length > 0) {
        <div class="pagination-controls">
          <div class="items-per-page">
            <label id="page-size-label" (click)="pageSizeSelect.focus()">Mostrar:</label>
            <mat-select #pageSizeSelect
              class="page-size-select"
              panelClass="publication-select-panel publication-page-size-panel"
              aria-labelledby="page-size-label"
              [formControl]="tamanoTabl">
              <mat-option value="6">6</mat-option>
              <mat-option value="12">12</mat-option>
              <mat-option value="24">24</mat-option>
            </mat-select>
            <span>por página</span>
          </div>
          <pagination-controls
            id="publications"
            (pageChange)="page = $event"
            previousLabel="Anterior"
            nextLabel="Siguiente">
          </pagination-controls>
        </div>
      }
    </div>
  </div>
</div>
